import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Icon from '../../Common/Icon';
import * as types from '../../../constants/actionTypes';
import { DEFAULT_PAGE_SIZE, DATETIME_FORMAT } from '../../../constants/constants';
import { createdFromNow } from '../../../helpers/dateTime.js';
import { actions as userAccessRequestActions } from '../../../actions/userAccessRequestActions';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { MultiSelect } from 'primereact/multiselect';
import UserRequestDrawer from './UserRequestDrawer';
import DocumentTitle from 'react-document-title';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import Moment from 'moment';

export class UserRequestsPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        const defaultRequest = {
            id: 0,
            subscriptionId: 0,
            firstName: '',
            lastName: '',
            defaultLocationName: '',
            additionalNotes: ''
        };

        this.state = {
            requests: [],
            defaultRequest: defaultRequest,
            selectedRequest: defaultRequest,
            isDrawerOpen: false,
            totalCount: 0,
            isLoading: false,
            locations: [],
            searchParams: {
                subscriptionId: this.props.subscriptionId,
                isActive: true,
                firstName: "",
                lastName: "",
                additionalNotes: "",
                locaitonIds: [],
                locations: [],
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "firstName",
                sortDir: "asc",
                returnAllResults: false
            },

        };
    }

    async componentDidMount() {
        this.loadListFilters();
        this.search();
    }

    loadListFilters = async () => {
        try {
            this.setState({ isLoading: true });
            const result = await this.props.userAccessRequestActions.loadListFilters(this.props.subscriptionId);
            const payload = result.payload;
            if (result.type === types.LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_SUCCESS) {
                this.setState({
                    locations: payload.locations
                });
            } else if (result.type === types.LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    search = async () => {
        try {
            this.setState({ isLoading: true });

            let locationIds = [];
            if (this.state.searchParams.locations.length > 0) {
                locationIds = this.state.searchParams.locations.map((item) => { return item.id });
            }

            const request = {
                ...this.state.searchParams,
                locationIds: locationIds
            }

            const result = await this.props.userAccessRequestActions.search(request);
            const payload = result.payload;
            if (result.type === types.SEARCH_USER_ACCESS_REQUEST_SUCCESS) {
                this.setState({
                    requests: payload.results,
                    totalCount: payload.totalCount
                });
            } else if (result.type === types.SEARCH_USER_ACCESS_REQUEST_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    selectRow = (e) => {
        const request = e.value;
        const selectedRequest = { ...this.state.defaultRequest, ...request };
        this.setState({ selectedRequest: selectedRequest, isDrawerOpen: true });
    }

    onLocationChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, locations: e.value } }, () => {
            this.search();
        });
    }

    filterChange = (e) => {
        let name = e.target.name;
        this.setState({ searchParams: { ...this.state.searchParams, [name]: e.target.value } });
    }

    onSearchBlur = () => {
        this.search();
    }

    keyUpFilter = (e) => {
        if (e.keyCode == 13) {
            this.search();
        }
    }

    onComplete = () => {
        this.setState({ isDrawerOpen: false });
        this.search();
    }

    onCancel = () => {
        this.setState({ isDrawerOpen: false });
    }

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: (e.page + 1) } }, () => {
            this.search();
        });
    }

    createdDateTemplate = (rowData) => {
        return <Fragment>
            <div>{Moment.utc(rowData.createdDate).format(DATETIME_FORMAT)}</div>
            <div>({createdFromNow(rowData.createdDate)})</div>
        </Fragment>
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState({
                searchParams: {
                    ...this.state.searchParams,
                    sortBy: sortBy,
                    sortDir: sortDir
                }
            }, this.search);
        }
    }

    render() {

        const firstNameFilter = <input type="text" name="firstName" placeholder="First Name" className="p-inputtext" size="50" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.state.searchParams.firstName} />;
        const lastNameFilter = <input type="text" name="lastName" placeholder="Last Name" className="p-inputtext" size="50" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.state.searchParams.lastName} />;
        const additionalNotesFilter = <input type="text" name="additionalNotes" placeholder="Notes" className="p-inputtext" size="50" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.state.searchParams.additionalNotes} />;
        const locationNameFilter = <MultiSelect className="ui-column-filter" optionLabel="name"
                appendTo={document.body}
                value={this.state.searchParams.locations}
                options={this.state.locations}
                onChange={this.onLocationChange} />;

        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                <DocumentTitle title="Admin" />
                <div className="identifier-header">
                    <div className="title">User Requests</div>
                    <div className="close">
                        <button type="button" onClick={this.props.onClose} alt="close popup"><Icon name="times" /></button>
                    </div>
                </div>

                <LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true}>
                    <div className="identifier-results-table">
                        <br />
                        <DataTable
                            filterDisplay="row"
                            className="p-datatable-sm p-datatable-striped"
                            resizableColumns={true} columnResizeMode="fit"
                            value={this.state.requests}
                            selectionMode="single"
                            selection={this.state.selectedRequest}
                            onSelectionChange={this.selectRow}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={this.onSort} >
                            <Column field="firstName" header="First Name" filter={true} filterElement={firstNameFilter} sortable={true} />
                            <Column field="lastName" header="Last Name" filter={true} filterElement={lastNameFilter} sortable={true} />
                            <Column field="defaultLocationName" header="Default Location" filter={true} filterElement={locationNameFilter} sortable={true} />
                            <Column field="additionalNotes" header="Notes" filter={true} filterElement={additionalNotesFilter} sortable={true} />
                            <Column field="createdDate" header="Created Date" sortable={true} body={this.createdDateTemplate}/>
                        </DataTable>
                        {
                            this.state.totalCount > this.state.searchParams.pageSize &&
                            <Paginator
                                rows={this.state.searchParams.pageSize}
                                totalRecords={this.state.totalCount}
                                first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                onPageChange={this.onPageChange} />
                        }
                        <div className="results-count">Total records: {this.state.totalCount}</div>
                    </div>
                </LoadingIndicator>

                {
                    this.state.isDrawerOpen
                        ?
                        <UserRequestDrawer
                            subscriptionId={this.props.subscriptionId.toString()}
                            userAccessRequestId={this.state.selectedRequest.id.toString()}
                            onComplete={this.onComplete}
                            onCancel={this.onCancel}
                            userAccessRequestActions={this.props.userAccessRequestActions} />
                        :
                        null
                }
            </div>
        );
    }

}

UserRequestsPage.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    userAccessRequestActions: PropTypes.object.isRequired
}

function mapDispatchToProps(dispatch) {
    return {
        userAccessRequestActions: bindActionCreators(userAccessRequestActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(UserRequestsPage);



